import { $api } from "@/utils/fetch.ts";

/**
 * Every scheduled trigger across the org's visible agents, paginated, for the
 * unified schedules dashboard on the Agents page. Org-scoped and
 * visibility-filtered on the server; the row count scales with the org's agents,
 * so it pages like the other org-wide lists.
 */
export const useAgentSchedulesInfiniteQuery = () =>
	$api.useInfiniteQuery(
		"get",
		"/api/agent-definitions/schedules",
		{ params: { query: {} } },
		{
			pageParamName: "page",
			initialPageParam: 0,
			getNextPageParam: (lastPage, _allPages, lastPageParam) =>
				lastPage.hasNextPage && typeof lastPageParam === "number"
					? lastPageParam + 1
					: undefined,
		},
	);

/**
 * openapi-react-query keys every query as [method, literalPath, init], and
 * TanStack's `partialMatchKey` compares element 2 by exact string. This prefix
 * therefore matches the org-wide schedules list (and only it — the
 * "/api/agent-definitions" prefix does NOT reach it, the literal paths differ).
 *
 * Every write that changes an agent's name or its triggers invalidates it: each
 * row here prints the agent name beside its cron, so the panel goes stale
 * otherwise.
 */
export const AGENT_SCHEDULES_QUERY_PREFIX = [
	"get",
	"/api/agent-definitions/schedules",
] as const;
